import { useInfiniteQuery } from "@tanstack/react-query";

import { createSearchTidLinkedAccountsInfiniteQueryOptions } from "@/api/graphql/billing/searchTidLinkedAccounts/queryOptions";
import { PAGINATION } from "@/constants/constants.ts";

import type { UseTidLinkedAccountsProps } from "./types";

export const useTidLinkedAccounts = ({
  getTidLinkedAccountsFn,
  accountId,
  enabled,
}: UseTidLinkedAccountsProps) => {
  const result = useInfiniteQuery(
    createSearchTidLinkedAccountsInfiniteQueryOptions({
      getTidLinkedAccountsFn,
      accountId,
      enabled,
    }),
  );

  const items = result.data?.pages.flatMap((page) => page.items) ?? [];
  const lastPage = result.data?.pages.at(-1);

  return {
    ...result,
    data: {
      items,
      pagination: lastPage?.pagination ?? {
        page: PAGINATION.DEFAULT_FIRST_PAGE,
        size: PAGINATION.DEFAULT_PER_PAGE,
        total: 0,
      },
    },
  };
};
